module.exports = __webpack_public_path__ + "img/featuredartist (3).fd0d1820.jpg";